/*
 * Default greeting ki teen lines — wahi jo backend ke getGreetingSection()
 * (server/src/services/agentCreationV2/promptHelpers.js) me hain aur prompt ke
 * ## Greeting section me jaati hain. UI inhe sirf dikhati hai; jo actually agent
 * ko jaata hai wo backend hi banata hai (frontend "Default" par customGreeting
 * khaali bhejta hai).
 *
 * Dono greeting screens — onboarding (BusinessStep/StepThree) aur edit
 * (EditNameAvtar/Step3) — yahin se padhti hain, taaki line badalni pade to ek hi
 * jagah badle. Backend wali copy bhi saath me update karni hoti hai.
 */
// `role` "pounce" ho to Pounce ka opener: wo agent call UTHATA nahi, lead ko
// khud call karta hai — "Thank you for calling…" wahan galat hai. Line wahi hai
// jo backend ke Pounce prompt (promptTemplates.js → "Pounce Receptionist") me
// hai; [ ] wale hisse har call pe us lead ke hisaab se bharte hain.
export const isPounceRole = (role) => String(role || "").trim().toLowerCase() === "pounce";

export const buildGreetingVariants = (
  businessName,
  agentName,
  role,
  { languageCode, isPythonBackend = false } = {},
) => {
  const biz = String(businessName || "").trim() || "our business";
  // Backend bhi pehla word hi use karta hai (agentName.split(" ")[0]).
  const agent = String(agentName || "").trim().split(" ")[0] || "your receptionist";

  if (isPythonBackend && languageCode === "hi-IN") {
    if (isPounceRole(role)) {
      return [
        `Namaste [lead's name], main ${agent}, ${biz} se. Maine dekha ki aapne [their inquiry] ke baare mein sampark kiya tha. Kya abhi baat karne ka sahi samay hai?`,
      ];
    }

    return [
      `Dhanyavaad, ${biz} ko call karne ke liye. Main ${agent} hoon. Aaj aapki kis tarah madad karun?`,
      `${biz}, main ${agent} hoon. Main aapke liye kya karun?`,
      `Namaste, ${biz} ko call karne ke liye shukriya. Main ${agent} hoon—bataiye, aapki kis tarah madad karun?`,
    ];
  }

  if (isPounceRole(role)) {
    return [
      `Hi [lead's name], this is ${agent} with ${biz}. I saw you just reached out regarding [their inquiry]. Did I catch you at an okay time?`,
    ];
  }

  return [
    `Thank you for calling ${biz}, this is ${agent}. How can I help you today?`,
    `${biz}, this is ${agent} speaking. What can I do for you?`,
    `Hi, thanks for calling ${biz}. This is ${agent}—how may I help you?`,
  ];
};

export default buildGreetingVariants;
